import React, { useState } from "react";
import {
  FormRadioCheckboxButton,
  FormRadioCheckboxGroup,
  Button
} from "@nef/core";
import { useWizard } from "react-use-wizard";
import { Controller, useFormContext } from "react-hook-form";

import StyledIssuerInformation from "../../../../../styles/IssuerInformation.styles";
import AddIssuerUi from "../../../../../CommonComponents/AddIssuerUi";

const IssuerInformation = () => {
  const { nextStep, previousStep } = useWizard();
  const { control, watch, setValue } = useFormContext();
  const [orgName, setOrgName] = useState(watch("organizationName"));

  return (
    <>
      <StyledIssuerInformation className="issuer-information">
        <Controller
          name="isFundIssuer"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <FormRadioCheckboxGroup
              id="isFundIssuer"
              name="isFundIssuer"
              type="radio"
              label="Are you a fund issuer, or fund administrator?"
              value={value}
              onChange={e => onChange(e.value === "true")}
            >
              <FormRadioCheckboxButton value={true} label="Yes" key={1} />,
              <FormRadioCheckboxButton value={false} label="No" key={2} />
            </FormRadioCheckboxGroup>
          )}
        />
        {/* Displayed only if "isFundIssuer" is true */}
        {watch("isFundIssuer") && (
          <>
            <Controller
              name="isSameAsOrgName"
              defaultValue={true}
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <FormRadioCheckboxButton
                  id="isSameAsOrgName"
                  name="isSameAsOrgName"
                  type="checkbox"
                  label="same as your organization name?"
                  checked={value}
                  onChange={e => {
                    if (e.checked) {
                      setOrgName(watch("organizationName"));

                    } else {
                      setOrgName("");
                    }
                    onChange(e.checked);
                  }}
                />
              )}
            />
            <br />
            <AddIssuerUi issuerName={orgName}   />
            <br />
            <br />
          </>
        )}
        <div className="action-buttons">
          <Button className="button" size="lg" onClick={() => previousStep()}>
            Back
          </Button>
          <Button className="button" size="lg" onClick={() => nextStep()}>
            Next
          </Button>
        </div>
      </StyledIssuerInformation>
    </>
  );
};
export default IssuerInformation;
